(function() {
    /* globals $, angular */
    'use strict';

    angular.module('dashboardApp').controller('accountController', Controller);
    Controller.$inject = [
        'Login',
        'Account',
        'Routing'
    ];

    function Controller (
        Login,
        Account,
        Routing
    ) {

        var vm = this;

        vm.showProgress = false;
        vm.error = null;
        vm.success = null;

        vm.oldPassword = null;
        vm.newPassword = null;
        vm.newPassword2 = null;



        vm.onSubmit = function() {
            vm.error = null;
            vm.success = null;

            if (!vm.oldPassword) {
                vm.error = "Please enter the current password";
                return;
            }
            if (!vm.newPassword) {
                vm.error = "The new password cannot be empty";
                return;
            }
            if (vm.newPassword !== vm.newPassword2) {
                vm.error = "The new password and the confirmation do not match.";
                return;
            }

            vm.showProgress = true;

            Account.updatePassword(
                vm.oldPassword,
                vm.newPassword
            ).then(function(response) {
                vm.showProgress = false;

                if (response.result) {
                    vm.success = "Password changed successfully.";
                    vm.oldPassword = null;
                    vm.newPassword = null;
                    vm.newPassword2 = null;

                } else {
                    vm.error = 'Password change failed. ' + response.message;
                }

            }).catch(function() {
                vm.error = 'Unknown failure.';
            });
        };



        vm.onCancel = function() {
            Routing.apps();
        };



        //----------- initialization ------------------

        function init() {
            Login.check().then(function(success) {
                if (!success) {
                    Routing.login();
                }
            });
        }


        init();


    }



})();
